<script>
  export let cardColor = "blue";
  export let cardTitle = "";
  export let cardSubTitle1 = "";
  export let cardSubTitle2 = "";
  export let cardSubTitle3 = "";

  export let cardLink = "#";
  export let cardFooter = undefined;
</script>

<div class="card-box bg-{cardColor}">
  <div class="inner">
    <h3>{cardTitle}</h3>
    <p>{cardSubTitle1}</p>
  </div>
  {#if cardSubTitle2 != "" && cardSubTitle3 != ""}
    <div class="inner">
      <div class="row justify-content-between">
        <div class="col">{cardSubTitle2}</div>
        <div class="col">{cardSubTitle3}</div>
      </div>
    </div>
  {/if}
  {#if cardLink !== "#"}
    <a href={cardLink} class="card-box-footer"
      >View More <i class="fa fa-arrow-circle-right" /></a
    >
  {/if}
  {#if cardFooter !== undefined}
    <span class="card-box-footer"> {cardFooter}</span>
  {/if}
</div>

<style>
  .card-box {
    position: relative;
    color: #fff;
    padding: 20px 10px 40px;
    margin: 20px 0px;
    border-radius: 10px;
  }
  .card-box:hover {
    text-decoration: none;
    color: #f1f1f1;
  }
  .card-box:hover .icon i {
    font-size: 100px;
    transition: 1s;
    -webkit-transition: 1s;
  }
  .card-box .inner {
    padding: 5px 10px 0 10px;
  }
  .card-box h3 {
    font-size: 27px;
    font-weight: bold;
    margin: 0 0 8px 0;
    white-space: nowrap;
    padding: 0;
    text-align: left;
  }
  .card-box p {
    font-size: 15px;
  }

  .card-box .card-box-footer {
    position: absolute;
    left: 0px;
    bottom: 0px;
    text-align: center;
    padding: 3px 0;
    color: rgba(255, 255, 255, 0.8);
    background: rgba(0, 0, 0, 0.1);
    width: 100%;
    text-decoration: none;
  }
  .card-box:hover .card-box-footer {
    background: rgba(0, 0, 0, 0.3);
  }
  .bg-blue {
    /*background-color: #00c0ef !important;*/
    background: linear-gradient(to bottom, #425e61, #00c0ef) !important;
  }
  .bg-green {
    /*background-color: #00a65a !important;*/
    background: linear-gradient(to bottom, #32493c, #00a65a) !important;
  }
  .bg-orange {
    /*background-color: #f39c12 !important;*/
    background: linear-gradient(to bottom, #493d32, #f39c12) !important;
  }
  .bg-red {
    /*background-color: #d9534f !important;*/
    background: linear-gradient(to bottom, #493232, #d9534f) !important;
  }
  .bg-cherry {
    background: linear-gradient(to bottom, #493240, #f09) !important;
    color: #fff;
  }
</style>
